import { useEffect } from "react";
import {
  CogentViewCard,
  installViewStyles,
  saidAfter,
} from "@softmax/cogent-sdk/react";
import type { CogentLive, CogentMessage } from "./chat-view";

/** What the cogent showed alongside a line, drawn by the SDK. */
export function MessageViews({
  message,
  live,
}: {
  message: CogentMessage;
  live: CogentLive;
}) {
  const shown = message.views?.length ?? 0;

  useEffect(() => {
    if (shown) installViewStyles();
  }, [shown]);

  return message.views?.map((view, index) => (
    <CogentViewCard
      key={index}
      view={view}
      host={{
        ask: (text) => void live.send({ text }),
        busy: !live.canSend,
        said: saidAfter(live.messages, message),
      }}
    />
  ));
}
